module.exports = __webpack_public_path__ + "static/johnfox-d1db2fa362c10cebddb59e33566cf5e4.png";